/* SOLCOZM NEW STREET 2.0 — Fase 2 (2026-10-21): tendine del menu accessibili.
   Mouse: apertura al passaggio (CSS :hover). Tastiera e touch: pulsante freccia [data-sc-nav-toggle]
   (Invio, Spazio o freccia giù). Esc chiude e riporta il focus sul pulsante. */
(function () {
  'use strict';
  var all = [];
  function toggleOf(item) { return item.querySelector('[data-sc-nav-toggle]'); }
  function setOpen(item, open) {
    var toggle = toggleOf(item);
    item.classList.toggle('is-open', open);
    if (open) item.classList.remove('is-dismissed');
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeOthers(except) {
    all.forEach(function (other) { if (other !== except) setOpen(other, false); });
  }
  function init(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('.sc-nav-item--has-dropdown'), function (item) {
      if (item.getAttribute('data-sc-nav-ready') === 'true') return;
      var toggle = toggleOf(item);
      var panel = item.querySelector('.sc-nav-dropdown');
      if (!toggle || !panel) return;
      item.setAttribute('data-sc-nav-ready', 'true');
      all.push(item);
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        var open = !item.classList.contains('is-open');
        closeOthers(item);
        setOpen(item, open);
      });
      item.addEventListener('mouseenter', function () {
        item.classList.remove('is-dismissed');
        toggle.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', function () {
        item.classList.remove('is-dismissed');
        if (!item.classList.contains('is-open')) toggle.setAttribute('aria-expanded', 'false');
      });
      item.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          var shown = item.classList.contains('is-open') || item.matches(':hover') || panel.contains(document.activeElement);
          if (!shown) return;
          event.preventDefault();
          event.stopPropagation();
          setOpen(item, false);
          item.classList.add('is-dismissed');
          toggle.focus();
        } else if (event.key === 'ArrowDown' && (event.target === toggle || event.target.classList.contains('sc-nav-item__link'))) {
          event.preventDefault();
          closeOthers(item);
          setOpen(item, true);
          var first = panel.querySelector('a');
          if (first) {
            first.focus();
            if (document.activeElement !== first) {
              window.setTimeout(function () { if (item.classList.contains('is-open')) first.focus(); }, 30);
            }
          }
        }
      });
      item.addEventListener('focusout', function (event) {
        if (!item.contains(event.relatedTarget)) setOpen(item, false);
      });
    });
  }
  document.addEventListener('click', function (event) {
    all.forEach(function (item) { if (!item.contains(event.target)) setOpen(item, false); });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { all = all.filter(function (i) { return document.contains(i); }); init(event.target); });
})();

/* Fase 35 + Fase 40 (2026-10-23) · pagina prodotto: taglie esaurite e combinazioni inesistenti.
   Fase 35: le taglie restano tutte visibili e cliccabili; esaurita = barrata (.is-soldout),
   inesistente nel colore scelto = tratteggiata (.is-nonexistent), con avviso IT/DE/EN.
   Fase 40: prima il clic su queste taglie veniva fermato qui e il tema non lo riceveva: restava selezionata
   la variante disponibile precedente e «Aggiungi al carrello» poteva aggiungerla per errore. Ora:
   - il clic arriva alla logica del tema: la taglia scelta diventa la selezione corrente, il pulsante si
     disattiva («Esaurito» / «Non disponibile») e perde l'ID della variante precedente;
   - l'avviso distingue taglia esaurita e combinazione inesistente;
   - subito prima dell'aggiunta al carrello si ricontrolla che la variante del pulsante sia esattamente
     quella scelta e disponibile; in caso contrario non viene aggiunto nulla.
   Nessuna variante, SKU, prezzo o disponibilità del catalogo viene modificata. */
(function () {
  'use strict';
  function parseJson(el) { try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function stateOf(pdp) {
    var variants = pdp.scSizeVariants || [];
    var sel = {};
    var complete = true;
    Array.prototype.forEach.call(pdp.querySelectorAll('[data-sc-pdp-option]'), function (g) {
      var b = g.querySelector('[data-value].is-selected');
      var idx = parseInt(g.getAttribute('data-option-index'), 10);
      sel[idx] = b ? b.getAttribute('data-value') : null;
      if (!b) complete = false;
    });
    var keys = Object.keys(sel);
    var variant = null;
    if (complete) {
      variant = variants.filter(function (v) {
        return keys.every(function (k) { return v['option' + k] === sel[k]; });
      })[0] || null;
    }
    return { sel: sel, variant: variant };
  }
  function syncNotice(pdp) {
    var notice = pdp.querySelector('[data-sc-pdp-notice]');
    var opts = pdp.scSizeOptions || {};
    var sizeIdx = parseInt(opts.sizeIndex, 10) || 0;
    if (!notice || !sizeIdx) return;
    var st = stateOf(pdp);
    var size = st.sel[sizeIdx];
    if (st.variant && st.variant.available) {
      notice.hidden = true;
      notice.textContent = '';
      return;
    }
    if (!size) return;
    var tpl = st.variant ? notice.getAttribute('data-template-sold') : notice.getAttribute('data-template');
    notice.textContent = (tpl || '').replace('[size]', size);
    notice.hidden = false;
  }
  function blockAdd(pdp, btn, st) {
    btn.removeAttribute('data-variant-id');
    btn.disabled = true;
    var label = btn.querySelector('[data-sc-add-label]');
    if (label) label.textContent = st.variant ? btn.getAttribute('data-label-unavailable') : btn.getAttribute('data-label-invalid');
    syncNotice(pdp);
  }
  function init(pdp) {
    if (!pdp || pdp.getAttribute('data-sc-size-states') === 'true') return;
    var variants = parseJson(pdp.querySelector('[data-sc-pdp-variants]'));
    var opts = parseJson(pdp.querySelector('[data-sc-pdp-options]'));
    if (!variants || !opts) return;
    pdp.scSizeVariants = variants;
    pdp.scSizeOptions = opts;
    pdp.setAttribute('data-sc-size-states', 'true');
    /* dopo la logica del tema (fase di risalita): avviso corretto per la selezione attuale */
    pdp.addEventListener('click', function (event) {
      if (event.target.closest && event.target.closest('[data-sc-pdp-option] [data-value]')) syncNotice(pdp);
    });
    var sizeIdx = parseInt(opts.sizeIndex, 10) || 0;
    var colorIdx = parseInt(opts.colorIndex, 10) || 0;
    if (!sizeIdx) return;
    var groups = Array.prototype.slice.call(pdp.querySelectorAll('[data-sc-pdp-option]'));
    var sizeGroup = groups.filter(function (g) { return parseInt(g.getAttribute('data-option-index'), 10) === sizeIdx; })[0];
    var colorGroup = groups.filter(function (g) { return parseInt(g.getAttribute('data-option-index'), 10) === colorIdx; })[0];
    if (!sizeGroup) return;
    var notice = pdp.querySelector('[data-sc-pdp-notice]');
    var labelNone = notice ? notice.getAttribute('data-label-none') : '';
    var labelSold = notice ? notice.getAttribute('data-label-sold') : '';
    var busy = false;
    function selectedOf(group) {
      var b = group ? group.querySelector('[data-value].is-selected') : null;
      return b ? b.getAttribute('data-value') : null;
    }
    function classify() {
      if (busy) return;
      busy = true;
      var color = colorIdx ? selectedOf(colorGroup) : null;
      sizeGroup.querySelectorAll('[data-value]').forEach(function (btn) {
        var size = btn.getAttribute('data-value');
        var match = variants.filter(function (v) {
          return v['option' + sizeIdx] === size && (!colorIdx || !color || v['option' + colorIdx] === color);
        });
        var state = !match.length ? 'none' : (match.some(function (v) { return v.available; }) ? 'ok' : 'sold');
        btn.classList.toggle('is-nonexistent', state === 'none');
        btn.classList.toggle('is-soldout', state === 'sold');
        if (state === 'ok') {
          if (btn.getAttribute('data-sc-state')) {
            btn.removeAttribute('data-sc-state');
            btn.removeAttribute('aria-label');
          }
        } else {
          /* resta visibile, focalizzabile e selezionabile; la disponibilita' e' annunciata nell'etichetta */
          if (btn.disabled) btn.disabled = false;
          if (btn.getAttribute('aria-disabled') !== 'false') btn.setAttribute('aria-disabled', 'false');
          btn.setAttribute('data-sc-state', state);
          btn.setAttribute('aria-label', size + ' — ' + (state === 'none' ? labelNone : labelSold));
        }
      });
      busy = false;
    }
    /* prima della logica del tema (fase di cattura): la taglia non deve risultare disattivata */
    sizeGroup.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-value]');
      if (btn && sizeGroup.contains(btn) && btn.disabled && btn.getAttribute('data-sc-state')) btn.disabled = false;
    }, true);
    var observer = new MutationObserver(function () { classify(); });
    groups.forEach(function (g) { observer.observe(g, { subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] }); });
    classify();
  }
  /* controllo finale prima dell'aggiunta al carrello (anche da tastiera: Invio/Spazio generano un clic) */
  window.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-sc-pdp-add]') : null;
    if (!btn) return;
    var pdp = btn.closest('[data-sc-product]');
    if (!pdp || !pdp.scSizeVariants) return;
    var st = stateOf(pdp);
    var ok = st.variant && st.variant.available && String(st.variant.id) === String(btn.getAttribute('data-variant-id'));
    if (ok) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    blockAdd(pdp, btn, st);
  }, true);
  function run() { Array.prototype.forEach.call(document.querySelectorAll('[data-sc-product]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.setTimeout(run, 0); });
  else window.setTimeout(run, 0);
  document.addEventListener('shopify:section:load', run);
})();


/* Fase 39 (2026-10-23): selettore lingua/valuta nell'header desktop.
   Un clic dentro il pannello (es. sul <select> dei paesi) arrivava fino al documento, che chiude
   tutti i pannelli: il select diventava invisibile e l'elenco nativo si chiudeva prima della scelta.
   I clic dentro il pannello non risalgono piu' al documento; il pannello si chiude ancora con un clic
   fuori, con Esc o con il pulsante. */
(function () {
  function bind(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-sc-loc-dropdown] .sc-header-loc__panel'), function (panel) {
      if (panel.getAttribute('data-sc-keep-open') === 'true') return;
      panel.setAttribute('data-sc-keep-open', 'true');
      panel.addEventListener('click', function (event) { event.stopPropagation(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  else bind(document);
  document.addEventListener('shopify:section:load', function (event) { bind(event.target); });
})();

